import { useMemo } from 'react';

import { mapAnalysisNiches } from '@/shared/api/mappers/analysis-stats';
import { useGetAnalysisNichesQuery } from '@/shared/hooks/queries/generated';

import type { AnalysisNiche } from '../types';

export const useAnalysisNiches = (analysisId: string) => {
  const { data, isLoading, error } = useGetAnalysisNichesQuery(
    { analysisId },
    {
      enabled: !!analysisId,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  );

  const niches = useMemo((): AnalysisNiche[] => {
    if (!data?.getAnalysisNiches) return [];
    return mapAnalysisNiches(data.getAnalysisNiches);
  }, [data]);

  return {
    niches,
    isLoading,
    error: (error as any)?.message,
  };
};
